module.exports = __webpack_public_path__ + "static/media/audience_and_tagging.8a531313.svg";